/* eslint-disable */
import { axiosInstanceLive } from 'instance/Axios';
import { handleCatchError } from 'utils/CatchHandler';
import { globalNotifyError, globalNotifySuccess } from 'views/utilities/AlertToast';

/**
 * Calls the given API endpoint with the provided payload + excel=1 to get full data,
 * then converts to CSV and triggers a browser download.
 *
 * @param {string} endpoint - The API endpoint (same as listing API)
 * @param {object} payload - The current filter/sort payload (without pagination)
 * @param {string} filename - The desired download filename (without extension)
 * @param {string[]} [columns] - Optional array of column keys to include in export
 * @param {object} [columnLabels] - Optional map of key → human-readable header
 */
export async function exportToExcel(endpoint, payload, filename, columns, columnLabels) {
    const token = localStorage.getItem('token');
    if (!token) {
        globalNotifyError('Session unavailable. Please log in again.');
        return;
    }

    try {
        const response = await axiosInstanceLive.post(
            endpoint,
            { ...payload, excel: 1 },
            {
                headers: { Authorization: `Bearer ${token}` },
                timeout: 60000
            }
        );

        const resData = response?.data;

        if (!resData?.success || !Array.isArray(resData.data) || resData.data.length === 0) {
            globalNotifyError('No data available to export.');
            return;
        }

        const data = resData.data;

        // Determine columns to export
        const exportColumns = columns || Object.keys(data[0]);
        const headers = exportColumns.map((col) => (columnLabels && columnLabels[col]) || col);

        // Build CSV content
        const csvRows = [];
        csvRows.push(headers.join(','));

        data.forEach((row) => {
            const values = exportColumns.map((col) => {
                const val = row[col];
                if (val === null || val === undefined) return '';
                const str = String(val).replace(/"/g, '""');
                // Wrap in quotes if contains comma, newline, or quotes
                return str.includes(',') || str.includes('\n') || str.includes('"') ? `"${str}"` : str;
            });
            csvRows.push(values.join(','));
        });

        const csvContent = csvRows.join('\n');
        const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${filename}_${new Date().toISOString().slice(0, 10)}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

        globalNotifySuccess('Export downloaded successfully.');
    } catch (err) {
        handleCatchError(err);
        globalNotifyError('Failed to export data. Please try again.');
    }
}
